import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import GoldZakatTable from "./GoldZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Gold_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = 'حساب زكاة الذهب 2026 - حاسبة نصاب زكاة الذهب';
const DESCRIPTION = "استخدم حاسبة زكاة الذهب لحساب المبلغ المستحق من الزكاة على الذهب بكل دقة، وذلك بناءً على الوزن، العيار، وسعر الجرام الحالي. أداة موثوقة ومطابقة للأحكام الشرعية.";
const KEYWORDS = 'زكاة الذهب, نصاب زكاة الذهب, حساب الزكاة, عيار 21, عيار 22, عيار 24, زكاة المال, فريضة الزكاة';
const OG_URL = 'https://do-calculate.com/calculator/ar/gold-zakat/';
const apiEndpoint = `${SERVER_URL}/${Gold_Zakat_EndPoint}`;
function GoldZakatCalculator() {
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [goldWeights, setGoldWeights] = useState([0, 0, 0, 0, 0, 0]);
    const goldKarats = [24, 22, 21, 18, 14, 10];
    const handleWeightsChange = (index, weight) => {
        const updatedWeights = [...goldWeights];
        updatedWeights[index] = parseFloat(weight);
        setGoldWeights(updatedWeights);
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateGoldZakat = async () => {
        const convertedGoldWeights = goldWeights.map((weight) => Number(weight));
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ goldWeights: convertedGoldWeights, goldKarats, gramPriceGold, yearType }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="rtl">
            <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '15px' }}>  احسب زكاة الذهب لأي عيار </h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    حاسبة زكاة الذهب هي أداة متطورة ودقيقة صُممت خصيصًا لتسهيل عملية حساب مقدار الزكاة الواجب دفعها على الذهب، بما يتوافق تمامًا مع أحكام الشريعة الإسلامية. اتبع الخطوات البسيطة التالية لاستخدام الحاسبة:
                                </p>
                                <ul>
                                    <li>
                                        <strong>أدخل وزن الذهب:</strong> حدد الوزن الإجمالي للذهب الذي تملكه بالجرامات.
                                    </li>
                                    <li>
                                        <strong>اختر عيار الذهب:</strong> اختر من بين العيارات المختلفة مثل 21، 22، أو 24 قيراط لتحديد نوع الذهب.
                                    </li>
                                    <li>
                                        <strong>أدخل سعر الجرام:</strong> أدخل سعر الجرام الحالي للعيار الذي اخترته.
                                    </li>
                                    <li>
                                        <strong>احسب الزكاة:</strong> اضغط على زر "حساب الزكاة" لمعرفة المبلغ المستحق دفعه كزكاة.
                                    </li>
                                    <li>
                                        <strong>راجع النتائج:</strong> تحقق من مبلغ الزكاة الواجب دفعه وتأكد من دقة البيانات المدخلة.
                                    </li>
                                </ul>
                                <p>
                                    بفضل هذه الأداة، يمكنك الاطمئنان إلى أنك تلتزم التزامًا كاملًا بتعاليم الإسلام وتؤدي واجبك الديني فيما يتعلق بزكاة الذهب، دون تعقيد أو مجهود.
                                </p>
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>حاسبة زكاة الذهب</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >نوع الحول</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            ميلادي
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id='hijri'
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            هجري
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    {goldKarats.map((karat, index) => (
                                        <div key={index}>
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor="amoutNumber" className="form-label ms-2">{`وزن الذهب عيار ${karat}`}</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="amoutNumber"
                                                    value={goldWeights[index]}
                                                    onChange={(e) => handleWeightsChange(index, e.target.value)}
                                                    className="form-control ml-2"
                                                    style={{ width: '150px' }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">غ</span>
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                    ))}
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">سعر غرام الذهب (24 قيراط)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceGold}
                                        onChange={handleGramPriceGoldChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateGoldZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'إحسب'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">النتائج: </div></h4>
                                            <hr />
                                            <GoldZakatTable result={result}></GoldZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                            </div>
                            <div className="info-section-body">
                                <p>{DESCRIPTION}</p>
                                <div>
                                    <h3 style={{ fontSize: '16px' }}>كيفية حساب زكاة الذهب</h3>
                                    <p>لحساب زكاة الذهب، تحتاج إلى معرفة بعض العوامل الأساسية مثل:</p>
                                    <ul>
                                        <li><strong>وزن الذهب:</strong> الوزن الإجمالي للذهب الذي تملكه.</li>
                                        <li><strong>عيار الذهب:</strong> نسبة النقاء في الذهب، مثل 21، 22، أو 24 قيراط.</li>
                                        <li><strong>سعر الجرام:</strong> السعر الحالي لكل جرام من الذهب.</li>
                                        <li><strong>التقويم:</strong> نوع السنة المستخدمة (هجري أو ميلادي).</li>
                                    </ul>
                                    <p>يتم أولاً تحويل وزن الذهب إلى الوزن الفعلي للذهب النقي بناءً على العيار. ثم، إذا تجاوز الوزن الصافي 85 جرامًا، تُحسب زكاة الذهب باستخدام نسبة الزكاة المقررة:</p>
                                    <ul>
                                        <li><strong>نسبة الزكاة في التقويم الهجري:</strong> 2.5%.</li>
                                        <li><strong>نسبة الزكاة في التقويم الميلادي:</strong> 2.577%.</li>
                                    </ul>
                                    <p>لحساب زكاة الذهب، يتم ضرب القيمة المحسوبة بنسب الزكاة بسعر الجرام الحالي للحصول على المبلغ المالي النهائي المستحق.</p>
                                    <p>ستقدم لك هذه الحاسبة النتائج على شكل تقرير يتضمن:</p>
                                    <ul>
                                        <li>إجمالي وزن الذهب النقي.</li>
                                        <li>تحديد ما إذا كانت زكاة الذهب مستحقة أم لا.</li>
                                        <li>المبلغ المالي الواجب دفعه كزكاة.</li>
                                        <li>مقدار زكاة الذهب نفسه.</li>
                                        <li>الحد الأدنى للوزن الذي يوجب الزكاة.</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h3 style={{ fontSize: '16px' }}>تطبيق الحاسبة في الدول العربية</h3>
                                    <p>تعد هذه الحاسبة أداة مفيدة لحساب زكاة الذهب في جميع الدول العربية، بما في ذلك:</p>
                                    <ul>
                                        <li>السعودية</li>
                                        <li>الإمارات العربية المتحدة</li>
                                        <li>مصر</li>
                                        <li>الأردن</li>
                                        <li>لبنان</li>
                                        <li>فلسطين</li>
                                        <li>الجزائر</li>
                                        <li>المغرب</li>
                                        <li>تونس</li>
                                        <li>اليمن</li>
                                        <li>عمان</li>
                                        <li>الكويت</li>
                                        <li>سوريا</li>
                                        <li>قطر</li>
                                        <li>السودان</li>
                                    </ul>
                                    <p>تم تطوير هذه الحاسبة لتلبية احتياجات الأفراد في هذه الدول وفقًا لمعايير الزكاة المعتمدة.</p>
                                    <p>للحصول على المزيد من المعلومات حول زكاة الذهب، يمكنك زيارة المصادر التالية:</p>
                                    <ul>
                                        <li><a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/" rel="nofollow noreferrer" target="_blank">الإغاثة الإسلامية عبر العالم</a></li>
                                    </ul>
                                    <p><strong>تاريخ آخر مراجعة:</strong> 28/02/2026</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GoldZakatCalculator;
